<template>
  <div class="header-box">
    <div class="header-left">
      <div class="logo clearfix">
        <div class="fl">
          <img v-if="!loginInfo.is_partner"
               src="../assets/logo_ld_blue.png"
               alt="">
          <img v-if="loginInfo.partner_logo_url"
               :src="loginInfo.partner_logo_url"
               alt="">
        </div>
        <div class="fl"
             v-if="!loginInfo.is_partner">
          <div class="logoTitle">魔镜社交聆听</div>
          <div class="logoText">MOOJING.COM</div>
        </div>
        <div class="fl"
             v-if="!loginInfo.is_partner">
          <el-popover placement="bottom"
                      trigger="hover">
            <div>
              <img src="../assets/kf.png"
                   alt="">
            </div>
            <div style="text-align:center;">扫码联系售后人员</div>
            <i class="iconfont icon-kefu kf"
               slot="reference"><span class="text">售后支持</span></i>
          </el-popover>
        </div>
        <div class="fl"
             v-if="!loginInfo.is_partner"
             style="line-height: 56px; margin-left: 20px; display: flex;">
          <i class="iconfont icon-wendang"
             style="font-size: 20px;"></i>
          <a href="https://qmctsz2s8t.feishu.cn/drive/folder/fldcnV5T1gGH5mQp6cBu1PVtPdc?from=space_persnoal_filelist"
             target="_blank"
             class="fileLink">产品文档</a>
        </div>
        <div class="fl"
             v-if="!loginInfo.is_partner">
          <el-popover placement="bottom"
                      trigger="hover">
            <div>
              <img src="../assets/kf2.png"
                   alt=""
                   style="width:200px;height:200px">
            </div>
            <div style="text-align:center;width:200px;">产品使用遇到问题！可扫码申请产品讲解或培训哦～</div>
            <i class="iconfont icon-kefu2 kf"
               slot="reference"><span class="text">申请讲解/培训</span></i>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="header-right">
      <div class="select"
           v-show="$route.name!=='search'&&$route.name!=='lifeDiscovery'">
        <el-select v-model="searchType"
                   size="small"
                   slot="prepend"
                   style="width:110px"
                   class="typeSearch"
                   :placeholder="$t('topHead.select_option_brand_holder')">
          <el-option v-for="item in searchOptions"
                     :key="item.value"
                     :label="item.name"
                     :value="item.value">
          </el-option>
        </el-select>

        <el-input v-show="searchType == 'keyWords'"
                  :placeholder="$t('topHead.select_option_postKeyWords_holder')"
                  style="width:16vw;min-width:120px;"
                  v-model="keyWards"
                  size="small">
          <el-button slot="append"
                     @click="searchKeyWards"
                     icon="el-icon-search"></el-button>
        </el-input>
        <!-- <CatSelectTrees ref="catSelectTree"
                        v-else-if="searchType == 'category'"
                        v-model="selectIds"
                        clearable
                        :width="300"
                        @cidChange="cidChange"
                        placeholder-text="选择类目"
                        :checkedKeys="defaultCheckedKeys"
                        @remove-tag="mulltipSelectRemoveTag"
                        @clear="clearSelect"></CatSelectTrees> -->
        <div style="display:inline-block"
             v-if="searchType == 'category'">
          <zTree v-model="selectIds"
                 treeDomId="selectZtree2"
                 treeDomSearchId="searchTree2"
                 @clear="clearSelect"
                 width="320"
                 @cidChange="cidChange"></zTree>
        </div>

        <el-select v-show="searchType == 'topic'"
                   v-model="topicName"
                   filterable
                   clearable
                   remote
                   multiple
                   collapse-tags
                   size="small"
                   :remote-method="remoteMethodTopic"
                   slot="prepend"
                   style="width:16vw;min-width:120px;"
                   :placeholder="$t('topHead.select_option_topic_holder')"
                   @clear="getTopics('','name')"
                   @remove-tag="handleRemoveTopic"
                   @change="changeTopicName">
          <el-option v-for="item in topicOptions"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
        <el-select v-show="searchType == 'brand'"
                   v-model="brandName"
                   filterable
                   clearable
                   remote
                   multiple
                   collapse-tags
                   size="small"
                   :remote-method="remoteMethod"
                   slot="prepend"
                   style="width:16vw;min-width:120px;"
                   :placeholder="$t('topHead.select_option_brand_holder')"
                   @clear="getBrands('','name')"
                   @remove-tag="handleRemove"
                   @change="changeBrandName">
          <el-option v-for="item in brandOptions"
                     :key="item.name"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </div>
      <div class="myAtention"
           v-show="false">
        <i class="iconfont icon-heart"
           style="color:#FF7875 ;margin-right:12px"></i>
        <span class="headText">{{$t('topHead.my_attention')}}</span>
      </div>
      <div class="complete"
           v-if="isCompleted">
        <el-tooltip effect="dark"
                    content="魔镜CMI布道师"
                    placement="top">
          <img src="../assets/medal.png"
               class="completeImg cp"
               :class="{'flicker':isCompletedMove}"
               @click="openHeadProduct">
        </el-tooltip>
      </div>
      <userinfo @userLogin="userLoginValue"
                @on-changeLanguage="changeLanguage"> </userinfo>

      <div class="language">
        <span @click="changeLanguge('zh')"
              :class="{'selected': localS.getItem('language')=='zh'}">{{$t('topHead.Chinese')}}</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="changeLanguge('en')"
              :class="{'selected': localS.getItem('language')=='en'}">{{$t('topHead.English')}}</span>
      </div>
    </div>

  </div>
</template>

<script>
import { getBrands, getTopic } from '@/api/search'
import { userinfo } from 'common'
import { parseTime, handelBrandNameOptions, getObjFromUrl } from '@/utils'
import zTree from './zTree.vue'
const localS = localStorage
const ZONE = 'Asia/Shanghai'
import { LuxonTime, pickerUtils } from 'common'
import Cookies from 'js-cookie'
export default {
  components: {
    userinfo,
    zTree,
  },
  data() {
    return {
      isCompleted: false,
      isCompletedMove: false,
      defaultCheckedKeys: [this.$store.state.user.catId],
      selectIds: [this.$store.state.user.catId],
      localS,
      lang: localS.getItem('language'),
      searchOptions: [
        {
          name: this.$t('topHead.select_option_category'),
          value: 'category',
        },
        { name: this.$t('topHead.select_option_brand'), value: 'brand' },
        { name: this.$t('topHead.select_option_topic'), value: 'topic' },
        {
          name: this.$t('topHead.select_option_postKeyWords'),
          value: 'keyWords',
        },
      ],
      brandOptions: [],
      topicOptions: [],
      titleWord: '',
      keyWards: this.$store.state.user.selectedKeyWards,
      topicName: this.$store.state.user.topicName,
      searchType: 'brand',
      brandName: this.$store.state.user.brandName,
      param_val: getObjFromUrl(window.location.href),
      cat: this.$store.state.user.catId,
      loginInfo: {},
    }
  },
  methods: {
    openHeadProduct() {
      this.$store.dispatch(
        'user/changeHeadProductIsShow',
        !this.$store.state.user.headProductIsShow
      )
    },
    userLoginValue(val) {
      const value = _.cloneDeep(val)
      this.loginInfo = value
      let org_start = localStorage.getItem('defaultStartMonth')
      let org_end = localStorage.getItem('defaultEndMonth')
      // 限制用户的选择权限
      if (org_end && org_start) {
        const { start, end } = value
        if (end && end !== org_end) {
          const param_val = getObjFromUrl(window.location.hash)
          const { start: param_start, end: param_end } = param_val
          if (param_start && param_end) {
          } else {
            if (LuxonTime.getTimeTs(end) < LuxonTime.getTimeTs(org_end)) {
              this.$store.dispatch('user/changeEndMonth', end)
              this.$store.dispatch('user/changeStartMonth', end)
              this.$store.dispatch('user/changeTsType', 'month')
            }
          }
        }
      }
      this.$store.dispatch('user/changeLoginInfo', value)
    },
    mulltipSelectRemoveTag() {},
    clearSelect() {
      this.selectIds = []
    },
    cidChange(cats) {
      if (cats != '' || cats.length != 0) {
        this.selectIds = _.map(cats, 'id')
        this.cat = _.map(cats, 'id').join(',')
        this.catName = _.map(cats, (item) => _.join(item.path, '>')).join(',')
      } else {
        this.selectIds = []
        this.cat = ''
        this.catName = ''
      }
      this.$store.dispatch('user/changeCatId', this.cat)
      this.$store.dispatch('user/changeCatName', this.catName)
    },
    changeTopicName(val) {
      if (val && val.length) {
        this.$store.dispatch('user/changeTopicName', val)
      } else {
        this.$store.dispatch('user/changeTopicName', [])
        this.$store.dispatch('user/changeCatId', '')
      }
    },
    changeBrandName(val) {
      if (val && val.length) {
        this.$store.dispatch('user/changeBrandName', val)
      } else {
        this.$store.dispatch('user/changeBrandName', [])
        this.$store.dispatch('user/changeCatId', '')
      }
    },
    handleRemove(key) {},
    handleRemoveTopic(key) {},
    searchKeyWards() {
      //   if (!(this.keyWards == '' && this.brandName == '' && this.cat == '')) {
      //     this.$store.dispatch(
      //       'user/changeSelectedKeyWards',
      //       this.keyWards.trim()
      //     )
      //   } else {
      //     this.$message.warning(this.$t('topHead.rules_message_search'))
      //     this.keyWards = this.$store.state.user.selectedKeyWards
      //   }
      this.$store.dispatch('user/changeSelectedKeyWards', this.keyWards.trim())
    },
    searchTopic() {},
    searchTitleWord() {
      //   if (
      //     !(this.titleWord == '' && this.brandName == '' && this.cat == '')
      //   ) {
      //     this.$store.dispatch(
      //       'user/changeSelectedTitleWord',
      //       this.titleWord.trim()
      //     )
      //   } else {
      //     this.$message.warning(this.$t('topHead.rules_message_search'))
      //     this.titleWord = this.$store.state.user.selectedtitleWord
      //   }
      this.$store.dispatch(
        'user/changeSelectedTitleWord',
        this.titleWord.trim()
      )
    },
    changeLoginState(val) {},
    /*
     type:查询类型  id:通过id精确查询，name：通过名称模糊查询
    */
    getBrands(paramVal = [], type = 'id') {
      this.loading = true
      let param = {}
      if (type == 'name') {
        param = { brand_name: paramVal }
      }
      getBrands(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.brandOptions = res.result.data
          }
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    getTopics(paramVal = [], type = 'id') {
      this.loading = true
      let param = {}
      if (type == 'name') {
        param = { topic_name: paramVal }
      }
      getTopic(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.topicOptions = res.result.data
          }
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.getBrands(query, 'name')
      }
    },
    remoteMethodTopic(query) {
      if (query !== '') {
        this.getTopics(query, 'name')
      }
    },
    //切换语言
    changeLanguge(lan) {
      // this.$i18n.locale = lan
      localStorage.setItem('language', lan)
      Cookies.set('cmiLanguage', lan, { path: '/', expires: 365, domain: 'mktindex.com' })
      location.reload()
    },
    changeLanguage(val) {
      if (this.lang !== val) {
        localStorage.setItem('language', val)
        location.reload()
      }
    },
  },
  watch: {
    '$store.state.user.urlParams': {
      handler(newVal, oldVal) {
        this.cat = newVal.cat_id
        this.selectIds = [newVal.cat_id]
        this.keyWards = newVal.word
        let brand_name = newVal.brand_name
        if (brand_name) {
          brand_name = brand_name.split(',')
        } else {
          brand_name = []
        }
        this.brandName = brand_name
        let topic_name = newVal.topic_name
        if (topic_name) {
          topic_name = topic_name.split(',')
        } else {
          topic_name = []
        }
        this.topicName = topic_name
        console.log(this.topicName)
      },
      deep: true,
    },
    '$store.state.user.headProductList': {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          let arr = _.filter(newVal, function (o) {
            return !o.status
          })
          if (arr.length > 0) {
            this.isCompleted = false
          } else {
            this.isCompleted = true
          }
        }
      },
      deep: true,
    },
    '$store.state.user.headProductCompletedMove': {
      handler(newVal, oldVal) {
        this.isCompletedMove = newVal
      },
    },
  },
  created() {
    this.getBrands('', 'name')
    this.getTopics('', 'name')
    const cookieLanguage = Cookies.get('cmiLanguage')
    const currentLanguage = localStorage.getItem('language')
    if (cookieLanguage && cookieLanguage !== currentLanguage) {
      localStorage.setItem('language', cookieLanguage)
      this.lang = cookieLanguage
      location.reload()
    }
    if (this.$store.state.user.headProductList.length > 0) {
      let arr = _.filter(this.$store.state.user.headProductList, function (o) {
        return !o.status
      })
      if (arr.length > 0) {
        this.isCompleted = false
      } else {
        this.isCompleted = true
      }
    }
  },
}
</script>

<style scoped lang='less'>
.header-left {
  color: #3a63f3;
  .lb {
    display: inline-block;
  }
  .logo {
    img {
      height: 35px;
      margin-top: 10px;
      margin-right: 12px;
    }
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    .logoTitle {
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #3a63f3;
      margin-top: 14px;
      line-height: 20px;
    }
    .logoText {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #3a63f3;
      transform: scale(0.7);
      text-align: center;
      line-height: 10px;
    }
    .fileLink {
      color: #3a63f3;
      font-size: 14px;
    }
  }
  .kf {
    margin-left: 30px;
    cursor: pointer;
    line-height: 56px;
    font-size: 20px;
  }
  .text {
    display: inline-block;
    font-size: 14px;
    vertical-align: top;
    margin-left: 4px;
  }
}
.complete {
  position: relative;
  width: 26px;
  height: 26px;
  margin-left: 10px;
}
.completeImg {
  width: 26px;
  height: 26px;
  z-index: 9999;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
